import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import SlidingText from '@jimmyboys/liita-ui/dist/components/SlidingText'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useMemo } from 'react'
import styles from './AppointmentDocuments.module.sass'

const AppointmentDocuments = (props) => {
	const { openFile } = useGlobal()
	const { data, ...attributes } = props

	const mappedDocuments = useMemo(
		() =>
			data.hasDocuments
				? data.documents.map((document) => (
						<HStack
							key={document?.id}
							className={styles['documents-list-item']}
						>
							<Icon name='clip' width='20px' height='20px' />
							<VStack className={styles['document']}>
								<button
									className={styles['document-button']}
									onClick={() => {
										const e = data?.documentsOptions.find(
											(item) => item?.id === document?.id
										)
										openFile && openFile(e)
										return true
									}}
								>
									<small>{document?.type?.name}</small>
								</button>
								<SlidingText
									className={styles['document-description']}
								>
									<small>{document?.description}</small>
								</SlidingText>
							</VStack>
						</HStack>
				  ))
				: '',
		[data.documents, data?.documentsOptions, data.hasDocuments, openFile]
	)

	return (
		<div {...attributes} className={styles['documents-container']}>
			<h5>{data.$cardLabels?.documents}</h5>
			<VStack>{mappedDocuments}</VStack>
		</div>
	)
}
export default AppointmentDocuments
